import { debounce } from './debounce';

export const bodyScrollClass = () => {
  let isScrolled = window.pageYOffset > 100 ? true : false

  const toggleScrollClass = (addOrRemove) => {
    document.body.classList.toggle('-scrolled', addOrRemove)
  }
  const handleScroll = () => {
    if (window.pageYOffset > 100 && isScrolled === false) {
      isScrolled = true;
      toggleScrollClass(isScrolled)
    } else if (window.pageYOffset <= 100 && isScrolled === true) {
      isScrolled = false;
      toggleScrollClass(isScrolled)
    }
  }
  window.addEventListener('scroll', debounce(handleScroll, 100))
  toggleScrollClass(isScrolled)
}